
import { useTranslations } from "next-intl";
import { useMemo } from "react";

export const useFormatDuration = () => {
  const tDuration = useTranslations(
    "SingleProductDescriptionFocusedDuration"
  );

  const formatDuration = useMemo(
    () => (duration: string) => {
      if (!duration) return "";
      const regex = /PT(?:(\d+)H)?(?:(\d+)M)?/;
      const matches = duration.match(regex);
      const hours =
        matches?.[1] && parseInt(matches[1]) > 0 ? `${matches[1]} ${tDuration("hr")}` : "";
      const minutes =
        matches?.[2] && parseInt(matches[2]) > 0 ? `${matches[2]} ${tDuration("min")}` : "";
      return `${hours}${hours && minutes ? " " : ""}${minutes}`.trim();
    },
    [tDuration]
  );

  return formatDuration;
};
